import { QUERY_KEYS } from '../../../../consts';
import { sendMobileVerificationCode } from '../../../../services';
import { getAtomWithMutation } from '../../../../utils';

export const sendMobileVerificationCodeAtom = getAtomWithMutation({
  mutationKey: QUERY_KEYS.USER.USER_INFO,
  mutationFn: () => sendMobileVerificationCode,
});
